import React from 'react'

import styled from 'styled-components'

import theme from 'theme'

import { Step } from './Step'

export type DiscreteProgressProps = Props

type Props = {
  barColor?: string
  className?: string
  complete?: boolean
  index: number
  responsiveSteps?: boolean
  steps: Step[]
  progress?: number
}

type AddedProps = {
  progress: number
  steps: Step[]
}

export type Step = { label: string; desc: string; tooltip?: string }

type InnerProps = Props & AddedProps

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
  height: 100%;
  max-width: 100%;
`

const BarContainer = styled.div`
  height: 150px;
  width: 4px;
  left: 1px;
  top: 8px;
  position: absolute;
  right: 1px;
  z-index: 1;
`

const Bar = styled.div`
  background-color: ${props => props.theme.colors.ivory};
  height: 100%;
  left: 0;
  position: absolute;
  right: 0;
  z-index: 1;
`

const StepBar = styled(Bar)<Partial<InnerProps>>`
  background-color: ${props => props.barColor};
  transition: all 300ms;
  height: ${props => props.progress * 100}%;
  border-radius: 0 100px 100px 0;
`

const StepContainer = styled.div`
  align-items: left;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  left: -8px;
  position: relative;
`

const VerticalProgressBar: React.ComponentClass<Props> = ({
  barColor,
  className,
  complete,
  index,
  progress,
  responsiveSteps,
  steps,
}) => {
  const current = index
  const progressPercentage = progress ? progress / 100 : index / (steps.length - 1)
  const stepBarColor = barColor ?? theme.colors.green

  return (
    <Container className={className}>
      <BarContainer>
        <Bar />

        <StepBar barColor={stepBarColor} progress={progressPercentage} />
      </BarContainer>

      <StepContainer>
        {steps.map((step, index) => {
          return (
            <Step
              bgColor={index <= current ? stepBarColor : theme.colors.ivory}
              isChecked={index < current}
              current={index === current}
              complete={complete}
              key={index}
              label={step.label}
              desc={step.desc}
              tooltip={step.tooltip}
              responsive={responsiveSteps}
            />
          )
        })}
      </StepContainer>
    </Container>
  )
}

export { VerticalProgressBar }
